module.exports = __webpack_public_path__ + "img/news-01.b5ea530e.jpg";